import React, { useState } from "react";
import styles from "./ReadMore.module.scss";
import clsx from "clsx";
import { Button } from "../Button/Button";
import { isPresent } from "../utils/checks";
import { IconsId } from "@silversea-ssc/design-system-icons";

export interface ReadMoreProps {
  openLabel?: string | JSX.Element;
  closeLabel?: string | JSX.Element;
  className?: string;
  height?: string;
  backgroundColor?: "white" | "neutral05" | "cssVariable";

  desktop?: boolean;
  tablet?: boolean;
  mobile?: boolean;
}

export const ReadMore: React.FC<React.PropsWithChildren<ReadMoreProps>> = ({
  openLabel,
  closeLabel,
  className = undefined,
  height = "150px",
  children,
  backgroundColor = "white",
  mobile = true,
  tablet = false,
  desktop = false
}) => {
  const [expanded, setExpanded] = useState(false);
  const withLabel = isPresent(openLabel) || isPresent(closeLabel);
  const iconName: IconsId = expanded ? "chevron-up" : "chevron-down";

  const dynamicContentMinHeight = {
    "--content-min-height": height
  } as React.CSSProperties;

  return (
    <div
      className={clsx(className, {
        [styles.expanded]: expanded,
        [styles.backgroundWhite]: backgroundColor == "white",
        [styles.backgroundGray]: backgroundColor == "neutral05",
        [styles.backgroundCssVariable]: backgroundColor == "cssVariable",
        [styles.activeMobile]: mobile,
        [styles.activeTablet]: tablet,
        [styles.activeDesktop]: desktop
      })}
    >
      <div
        className={styles.content}
        style={dynamicContentMinHeight}
        //style={{ maxHeight: expanded ? "auto" : height }}
      >
        {children}
      </div>

      <Button
        renderAs="button"
        className={styles.button}
        variant="text"
        iconName={iconName}
        onClick={() => {
          setExpanded(!expanded);
        }}
        dataContentPiece={expanded ? "collapse" : "expand"}
        full
      >
        {withLabel ? (expanded ? closeLabel : openLabel) : null}
      </Button>
    </div>
  );
};
